export default {

    deepClone(o) {
        return JSON.parse(JSON.stringify(o));
    },

}